import React from 'react';
import { withStyles } from '@material-ui/core';
import MaintenancePageStyles from './MaintenancePage.component.styles';
import { compose } from 'recompose';
import { Typography, Slide, Grid } from '@material-ui/core';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import BoralLogoUrl from '../../Assets/Logos/Boral-84x69.png';

const MaintenancePageComponent = ({ classes }) => {
  return (
    <Grid container className={classes.maintenanceContainer}>
      <Grid item xs={12}>
        <img alt="Boral" src={BoralLogoUrl} className={classes.image} />
      </Grid>
      <Grid item xs={12}>
        <Typography variant="h5" className={classes.mainText}>We apologise for the inconvenience, but we&apos;re currently performing some maintenance. Please call Boral if you require assistance. We&apos;ll be back up soon.</Typography>
      </Grid>
    </Grid>
  );
};

const MaintenancePage = compose(
  withStyles(themeCreateInjectableStyles(MaintenancePageStyles), { withTheme: true }),
)(MaintenancePageComponent);

export default MaintenancePage;
